
export default function HiddenField({ input }) {
    return (
        <input {...input} id={input.name} value={input.value || ""} data-test-id={input.name} type="hidden" />
    );
}
